// extracted by mini-css-extract-plugin
export var cardTitle = "_ic-1";
export var commentBubble = "_ic-e";
export var commentForm = "_ic-a";
export var commentInput = "_ic-b";
export var commentLabel = "_ic-d";
export var commentPrompt = "_ic-9";
export var csatCard = "_ic-0";
export var feedbackSection = "_ic-7";
export var starDisabled = "_ic-6";
export var starEmpty = "_ic-5";
export var starFilled = "_ic-4";
export var starWrapper = "_ic-3";
export var starsContainer = "_ic-2";
export var submittedComment = "_ic-c";
export var thankYouText = "_ic-8";